/**
 * Three column carousel - carousel on tablet down
 * https://owlcarousel2.github.io/
 */

import 'imagesloaded';
import 'masonry-layout/masonry.js';
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';

export function imageGallery() {
  if (jQuery(".image-gallery").length === 0) return;

  // Init Masonry layout
  jQuery('.image-gallery').imagesLoaded(function() {
    jQuery('.image-gallery').masonry({
      itemSelector: '.image-gallery__item',
      horizontalOrder: true,
      percentPosition: true
    });
  });

  // Accessibility: wrap gallery images in <button> for semantic interactivity
  jQuery('.image-gallery img[data-src-viewer]').each(function() {
    const $img = jQuery(this);
    const altText = $img.attr('alt');

    const $btn = jQuery('<button>', {
      type: 'button',
      'aria-haspopup': 'dialog',
      'aria-label': altText || 'Åbn billede i fremviser',
      class: 'image-gallery__trigger'
    });

    $img.wrap($btn);
    // Image is presentational inside the button — the button carries the accessible name
    $img.attr('alt', '');
  });

  // Keyboard activation: Enter/Space on button triggers click on img inside so ViewerJS handles it
  jQuery(document).on('keydown', '.image-gallery__trigger', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      jQuery(this).find('img').trigger('click');
    }
  });

  // Track which trigger opened the viewer so focus can be restored on close
  let $lastTrigger = null;
  jQuery(document).on('click', '.image-gallery__trigger', function() {
    $lastTrigger = jQuery(this);
  });

  // Focus trap: keeps Tab/Shift+Tab cycling inside the viewer while it is open
  function handleFocusTrap(e) {
    if (e.key !== 'Tab') return;
    const viewerEl = document.querySelector('.viewer-container.viewer-open');
    if (!viewerEl) return;

    const focusable = Array.from(viewerEl.querySelectorAll(
      '[role="button"][tabindex="0"], a[href], button:not([disabled])'
    )).filter(el => el.offsetParent !== null);

    if (focusable.length < 2) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // Initialize ViewerJS for each gallery
  const galleries = jQuery(".image-gallery");
  galleries.each(function(_, element) {

    new Viewer(element, {
      backdrop: true,
      button: true,
      inheritedAttributes: ['data-caption', 'data-src-download'],
      title(image) {
        return image.getAttribute('data-caption');
      },

      url(image) {
        return image.getAttribute('data-src-viewer') || image.src;
      },

      toolbar: {
        zoomIn:  { show: true, title: 'Zoom ind' },
        zoomOut: { show: true, title: 'Zoom ud' },
        prev:    { show: true, title: 'Forrige billede' },
        next:    { show: true, title: 'Næste billede' },
      },

      transition: false,

      shown() {
        const viewerEl = this.viewer.viewer;

        // Set aria-label on close button
        const closeBtn = viewerEl.querySelector('.viewer-button');
        if (closeBtn) closeBtn.setAttribute('aria-label', 'Luk fremviser');

        // Set aria-label on toolbar buttons (ViewerJS sets title, not aria-label)
        const toolbarLabels = {
          'viewer-zoom-in':  'Zoom ind',
          'viewer-zoom-out': 'Zoom ud',
          'viewer-prev':     'Forrige billede',
          'viewer-next':     'Næste billede',
        };
        Object.entries(toolbarLabels).forEach(([cls, label]) => {
          const btn = viewerEl.querySelector('.' + cls);
          if (btn) btn.setAttribute('aria-label', label);
        });

        // Move initial focus to close button so keyboard users land inside the dialog
        if (closeBtn) closeBtn.focus();

        // Activate focus trap
        jQuery(document).on('keydown.galleryTrap', handleFocusTrap);
      },

      hidden() {
        // Deactivate focus trap
        jQuery(document).off('keydown.galleryTrap');

        // Return focus to the trigger that opened the viewer
        if ($lastTrigger) {
          $lastTrigger.focus();
          $lastTrigger = null;
        }
      },

      viewed() {
        const viewer = this.viewer;
        const container = viewer.viewer;
        const image = viewer.image;

        // Safeguard against undefined (in older ViewerJS builds)
        if (!image) return;

        // Remove previous download button
        container.querySelector('.viewer-download-btn')?.remove();

        // Read download attribute directly — fallback
        const downloadUrl = image.getAttribute('data-src-download');

        if (!downloadUrl) return;

        // Create the button
        const btn = document.createElement('a');
        btn.href = downloadUrl;
        btn.download = '';
        btn.className = 'viewer-download-btn';
        btn.title = 'Download billede';
        btn.setAttribute('aria-label', 'Download billede');
        btn.innerHTML = '<div><span class="icon-download"></span></div>';

        // Click event
        btn.onclick = () => {
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = '';
          a.rel = 'noopener';
          document.body.appendChild(a);
          a.click();
          a.remove();
        };

        container.appendChild(btn);
      },

    });
  });
}

export default imageGallery;
